import {TextInput} from '@components/common/text-input/text-input'
import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {useMessageForwardingStore} from '../message-forwarding-store'

const TwSearch = tw.div`
  p-8
  border
  border-t-0
  border-l-0
  border-r-0
  border-solid
  bg-main-old
  border-lists-divider-old
`

export const Search = observer(() => {
  const [state, store] = useMessageForwardingStore()
  return (
    <TwSearch>
      <TextInput
        autoFocus={false}
        placeholder={Lang.msg.chat.searchInChats}
        large
        searchIcon={false}
        value={state.query}
        onChange={e => store.inputQuery(e)}
      />
    </TwSearch>
  )
})
